// Room Settings API functions
import { getData, deleteData, postData, putData } from '../apiClient';

// Get bed types with pagination
export const getBedTypesWithPagination = async ({ page = 1, limit = 10, search = '' }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search
        });

        const result = await getData(`/bed-type/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get bed types API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: [],
                totalPages: 1,
                prevPage: false,
                nextPage: false,
                totalDocs: 0,
                page: 1
            }
        };
    }
};

// Get single bed type by ID
export const getBedTypeById = async (id) => {
    try {
        const result = await getData(`/bed-type/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Get bed type by ID API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};

// Create new bed type
export const createBedType = async ({data}) => {
    try {
        const result = await postData("/bed-type/create-bed", data);
        return {
            data: {
                success: true,
                data: result,
              },
        };
    } catch (error) {
        console.error("user add API error:",  error);
        return {
            data: {
                success: false,       
                error: error.status === 400 ? error.data.errors : error.message,
                status: error.status,
              },
        };
    }
};

// Update bed type
export const updateBedType = async ({id, data}) => {
    try {
        const result = await putData(`/bed-type/update-bed/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
              },
        };
    } catch (error) {
        console.error('Update bed type API error:', error);
        return {
            data: {
                success: false,       
                error: error.status === 400 ? error.data.errors : error.message,
                status: error.status,
              },
        };
    }
};

// Delete bed type
export const deleteBedType = async ({ id }) => {
    try {
        const result = await deleteData(`/bed-type/delete-bed/${id}`);
        return {
            success: true,
            ...result
        };
    } catch (error) {
        console.error('Delete bed type API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: null
            }
        };
    }
};